import gql from 'graphql-tag'

export const COMMISSION_SPLIT_DELETE_MUTATION = gql`
    mutation commissionSplitDelete($id: ID!) {
        commissionSplitDelete(id: $id) {
            status
        }
    }
`
